import maintainRequest from "@/maintain/utils/maintainRequest";

export default function maintainGetOnlyChargeDeviceGroupIdNameList(params) {
  return maintainRequest({
    url: `/device/maintenanceMan/deviceGroup/getOnlyChargeDeviceGroupIdNameList`,
    params,
  });
}
